"use client";

import { useId, useRef } from "react";
import { useTranslations } from "next-intl";
import type { MediaChromeMenu as MediaChromeMenuElement } from "media-chrome/dist/menu/media-chrome-menu.js";
import { MediaChromeMenu, MediaChromeMenuButton, MediaChromeMenuItem } from "media-chrome/react/menu";

export function VideoQualityMenu({ levels, quality, onSelect }: {
  levels: Array<{ index: number; height: number }>;
  quality: number;
  onSelect: (index: number) => void;
}) {
  const t = useTranslations("site.video");
  const id = `video-quality-${useId().replace(/[^a-zA-Z0-9_-]/g, "")}`;
  const menuRef = useRef<MediaChromeMenuElement>(null);
  const options = [{ index: -1, label: t("qualityAuto") }, ...levels.map(level => ({ index: level.index, label: `${level.height}p` }))];
  if (!levels.length) return null;
  function toggle(open: boolean) {
    if (menuRef.current) menuRef.current.hidden = !open;
  }
  return <div className="video_tiao_bei_kuang" onPointerEnter={event => { if (event.pointerType === "mouse") toggle(true); }} onPointerLeave={event => { if (event.pointerType === "mouse") toggle(false); }}>
    <MediaChromeMenuButton id={`${id}-button`} invokeTarget={id} aria-label={t("quality")} aria-haspopup="menu" className="video_tiao_qing_button">
      {options.find(option => option.index === quality)?.label ?? t("qualityAuto")}
    </MediaChromeMenuButton>
    <MediaChromeMenu ref={menuRef} id={id} anchor={`${id}-button`} className="video_tiao_bei video_tiao_qing" aria-label={t("quality")} hidden onChange={event => {
      const index = Number(event.currentTarget.value);
      if (options.some(option => option.index === index)) onSelect(index);
      toggle(false);
    }}>
      {options.map(option => <MediaChromeMenuItem key={option.index} type="radio" value={String(option.index)} checked={quality === option.index}><span>{option.label}</span></MediaChromeMenuItem>)}
    </MediaChromeMenu>
  </div>;
}
